import { useTranslation } from 'react-i18next';
import BasicModal from '@ui-parts/BasicModal';
import Button from '@ui-elements/Button';
import { ButtonProps, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import styled from 'styled-components';
import { PALETTE } from '~/assets/styles/base';

const ModalHeader = styled.div`
  display: flex;
  margin: 25px;
`;

const ValidationErrorInfo = styled.div`
  display: flex;
  align-items: center;
  padding-top: 20px;
`;

const ValidationNote = styled(Typography)`
  font-size: 18px;
  color: ${PALETTE.text.area};
  margin-bottom: 11px;
`;

type Props = {
  open: boolean;
  handleClose: React.MouseEventHandler<HTMLButtonElement>;
  validationMsg: string;
};

const FormValidationModal: React.FC<Props & ButtonProps> = ({
  open,
  handleClose,
  validationMsg,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  const customModalTitle = (
    <ModalHeader data-testid="validationErrorModalHeader" data-key="validationErrorModalHeader">
      <WarningIcon sx={{ fontSize: '21px', marginTop: '6px', color: PALETTE.text.sub }} />
      <Typography
        sx={{
          fontWeight: 'medium',
          fontSize: '20px',
          marginLeft: '14px',
          color: PALETTE.text.area,
        }}
      >
        {t('registration.originalForm.validationErrorModal.title')}
      </Typography>
    </ModalHeader>
  );

  return (
    <BasicModal
      open={open}
      titleProps={{
        customModalTitle,
      }}
      handleClose={handleClose}
      buttons={[
        <div key="ModalFooterInner">
          <Button
            onClick={handleClose}
            colorType="navy"
            width="150px"
            dataTestId="validationErrorModalButton"
            variant="contained"
          >
            {t('appCommon.back')}
          </Button>
        </div>,
      ]}
      dataTestId="validationErrorModal"
      width="526px"
    >
      <ValidationErrorInfo>
        <ValidationNote data-testid="validationMsg">{validationMsg}</ValidationNote>
      </ValidationErrorInfo>
    </BasicModal>
  );
};

export default FormValidationModal;
